module.exports = __webpack_public_path__ + "img/img_exterior04.88d6155f.jpg";